// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';

// MUI components
import Box from '@mui/material/Box';
import ReviewItem from '@components/MansionDetail/MansionReview/ReviewItem';
import ReviewItemEmpty from '@components/MansionDetail/MansionReview/ReviewItemEmpty';

// Section for import custom components --------------------------------------------------------------------------------
import { MansionReviewContext } from '@providers/MansionDetail/MansionReview/MansionReviewProvider';

// Section for type definition -----------------------------------------------------------------------------------------
import { MansionReviewContextType } from '@/types/components/MansionDetail/MansionReviewPropsData';

type ReviewListProps = {
  category: string;
};

export default function ReviewList(props: ReviewListProps): React.JSX.Element {
  const { category } = props;
  const mansionReviewContext = useContext(MansionReviewContext);
  // @ts-ignore
  const { mansionReview } = mansionReviewContext;
  const { isReview } = mansionReview.category[category];
  const firstTenReviewItems: MansionReviewContextType[] = isReview
    ? mansionReview.category[category].reviews.slice(0, 10)
    : [];

  return (
    <Box>
      <Box className={`${category === 'hope' ? 'mb-4 max-md:mb-3' : 'mb-10 max-md:mb-8'} max-md:mx-5`}>
        {isReview ? (
          firstTenReviewItems.map((reviewItem: any) => (
            <Box key={reviewItem.id} className="mb-4 max-md:mb-3">
              <ReviewItem
                reviewId={reviewItem.id}
                contents={reviewItem.review.contents}
                reviewDate={reviewItem.review.reviewDate}
                reviewer={reviewItem.review.reviewer}
                score={reviewItem.review.score}
                category={category}
              />
            </Box>
          ))
        ) : (
          <ReviewItemEmpty />
        )}
      </Box>
    </Box>
  );
}
